import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryScroll() {
  const { t } = useTranslation();
  const displayCategories = categories.slice(0, 8);

  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="px-6 md:px-10 max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
              {t('section_categories_title')}
            </h2>
          </div>
          <p className="hidden md:block text-sm text-foreground-500 font-label">
            {t('section_categories_subtitle')}
          </p>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 -mx-2 px-2">
          {displayCategories.map((cat, index) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-60 h-72 rounded-xl overflow-hidden relative group cursor-pointer"
            >
              <img
                src={cat.imageUrl}
                alt={cat.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-white text-lg font-heading font-semibold">{cat.name}</h3>
                <p className="text-white/70 text-xs mt-1">{cat.desc}</p>
              </div>
              <span className="absolute top-4 right-4 bg-white/20 backdrop-blur-sm text-white text-xs px-2.5 py-1 rounded-full font-label">
                {String(index + 1).padStart(2, '0')}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}